import styled from "styled-components";

export const ResumoParcelasSelecionadas = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 2;
  display: flex;
  background-color: white;

  @media (max-width: 820px) {
    display: none;
  }
`;

export const FirstSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 40%;
  border-bottom-width: 0px;
`;

export const TextoSimples = styled.div`
  height: 40px;

  align-items: center;
  display: flex;
  border: 1px solid #d1d1d1;
  border-top-width: 2px;
  font-size: 12px;
  font-weight: bold;
  color: #4d4d4d;
  margin-left: 0px;
  padding-left: 16px;
`;

export const ParcelasSelecionadas = styled.div`
  background-color: ${(props) => props.tema.primaryColor};

  height: 64px;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  display: flex;
  align-items: center;
  padding-left: 16px;

  p {
    align-items: center;
    display: flex;
    box-sizing: border-box;
  }
`;

export const SecondSection = styled.div`
  width: 100%;
  box-sizing: border-box;
  margin-top: 0;
  height: 64px;
`;

export const ContainerIconeParcela = styled.div`
  background-color: ${(props) => props.tema.primaryColor};
  width: 36px;
  height: 36px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  margin-right: 8px;
  svg {
    width: 22px;
    height: 22px;
    * {
      fill: #fff !important;
    }
  }
`;

export const ContainerValorTotal = styled.div`
  display: flex;
  align-items: center;
  padding-left: 16px;
  width: 100%;
  .labelValorTotal {
    font-size: 12px;
    display: block;
  }
  .valorTotal {
    font-size: 20px;
    font-weight: bold;
    color: #4d4d4d;
  }
`;

export const ContainerPayment = styled.div`
  border: 2px solid ${(props) => props.tema.primaryColor};
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-left-width: 0;
  align-items: center;
  height: 64px;

  color: #4d4d4d;
`;

export const ContainerPaymentMethod = styled.div`
  display: flex;
  margin-right: 8px;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;
  font-size: 12px;
  box-sizing: border-box;
`;
